export const brand = {
  name: 'WayWeWander',
  tagline: 'Travel Beyond Boundaries.',
  logoPath: '/assets/waywewander-logo.jpeg',
  email: 'wearewaywewander@gmail.com',
  phoneNumbers: ['+917349151300', '+919392796841'],
  whatsappNumbers: ['+917349151300', '+919392796841'],
  whatsappUrls: [
    'https://wa.me/917349151300',
    'https://wa.me/919392796841',
  ],
  instagramHandle: 'way_we_wander',
  instagramUrl: 'https://www.instagram.com/way_we_wander?igsh=MXNxdmRmMnkzbHNubA==',
  address: 'Hyderabad, Telangana, India',
};

export const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Trips', path: '/trips' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

export const tripCategories = [
  'Adventure',
  'International',
  'Domestic',
  'Hidden Gems',
  'Family',
  'Honeymoon',
  'Weekend',
  'Luxury',
];

export const travelStats = [
  { label: 'Curated journeys', value: '120+' },
  { label: 'Happy travelers', value: '8.5K+' },
  { label: 'Average rating', value: '4.9' },
  { label: 'Expert partners', value: '60+' },
];

export const whyChoose = [
  {
    title: 'Handpicked stays',
    text: 'Boutique hotels, characterful homestays, and reliable comfort checks before every departure.',
  },
  {
    title: 'Local-led routes',
    text: 'Trips are designed with operators, guides, and hosts who know the terrain beyond the obvious stops.',
  },
  {
    title: 'Transparent planning',
    text: 'Clear inclusions, realistic pacing, and callback support before you commit to your dates.',
  },
  {
    title: 'Premium support',
    text: 'On-trip coordination, WhatsApp assistance, and trusted partners for smoother travel days.',
  },
];

export const testimonials = [
  {
    name: 'Ananya Rao',
    place: 'Mumbai',
    quote:
      'The Ladakh route felt adventurous without ever feeling chaotic. Every stay and stop had a point of view.',
  },
  {
    name: 'Karan Mehta',
    place: 'Delhi',
    quote:
      'Our Bali honeymoon was balanced beautifully between quiet villas, food walks, and real exploration.',
  },
  {
    name: 'Nisha Thomas',
    place: 'Kochi',
    quote:
      'They understood our family pace and built a Kerala holiday that worked for three generations.',
  },
];

export const blogPreviews = [
  {
    title: 'How to choose the right Himalayan trip window',
    category: 'Planning',
    date: 'July 18, 2026',
  },
  {
    title: 'What premium travel support actually includes',
    category: 'Guides',
    date: 'July 09, 2026',
  },
  {
    title: 'Slow travel ideas for couples who dislike rushed itineraries',
    category: 'Inspiration',
    date: 'June 28, 2026',
  },
];

export const homeFaqs = [
  {
    question: 'Can WayWeWander customize a listed trip?',
    answer:
      'Yes. Listed routes are starting points. Dates, stay category, pacing, and experiences can be tailored after a planning callback.',
  },
  {
    question: 'Do I need to pay before speaking with an expert?',
    answer:
      'No. Submit your preferences first and our team will help you understand route, budget, and availability.',
  },
  {
    question: 'Are trips suitable for first-time travelers?',
    answer:
      'Many are. Difficulty, altitude, weather, and travel style are mentioned clearly so you can choose confidently.',
  },
];

export const partnerNames = ['Mountain Guild', 'Coastal Table', 'Heritage Homes', 'Vista Trails'];

export const policyPages = {
  privacy: {
    title: 'Privacy Policy',
    description:
      'How WayWeWander handles traveler information, callback requests, and communication preferences.',
    sections: [
      {
        heading: 'Information we collect',
        body:
          'We collect details you submit through forms, including name, contact information, preferred travel dates, destination interests, and trip notes.',
      },
      {
        heading: 'How we use it',
        body:
          'Your information is used to respond to inquiries, prepare travel recommendations, coordinate trip planning, and improve our service quality.',
      },
      {
        heading: 'Traveler reviews',
        body:
          'When you submit a review, we retain the contact details needed to verify it. We publish only the review details you consent to share, such as your name, trip, ratings, and feedback, after verification.',
      },
      {
        heading: 'Data sharing',
        body:
          'We share only the details required with trusted travel partners when a quote, booking, or trip operation requires it.',
      },
      {
        heading: 'Your choices',
        body:
          'You can request correction or deletion of your submitted information by contacting our team through the email listed on this website.',
      },
    ],
  },
  terms: {
    title: 'Terms & Conditions',
    description:
      'The core booking, payment, traveler responsibility, and service terms for WayWeWander trips.',
    sections: [
      {
        heading: 'Trip quotes',
        body:
          'Prices depend on dates, group size, stay category, transport availability, and inclusions confirmed during consultation.',
      },
      {
        heading: 'Bookings',
        body:
          'A booking is confirmed only after agreed payment, traveler details, and written confirmation from WayWeWander.',
      },
      {
        heading: 'Traveler responsibility',
        body:
          'Travelers are responsible for accurate documents, health disclosures, local-law compliance, and timely arrival for departures.',
      },
      {
        heading: 'Changes',
        body:
          'Weather, road conditions, permits, or supplier constraints may require practical itinerary adjustments while preserving trip intent.',
      },
    ],
  },
  cancellation: {
    title: 'Cancellation Policy',
    description:
      'Cancellation terms are designed to be clear before payment and practical for destination operations.',
    sections: [
      {
        heading: 'Before confirmation',
        body:
          'No cancellation charge applies before a trip is confirmed through payment and written acknowledgement.',
      },
      {
        heading: 'After confirmation',
        body:
          'Cancellation charges vary by destination, departure date, supplier terms, and non-refundable permits or stays.',
      },
      {
        heading: 'Force majeure',
        body:
          'Weather events, closures, strikes, or safety concerns may require rescheduling or credit-based alternatives based on supplier policies.',
      },
      {
        heading: 'Refund timelines',
        body:
          'Approved refunds are processed after supplier reconciliation and may take standard banking timelines to reflect.',
      },
    ],
  },
};
